var _defs, _circle, _circle2, _circle3, _style;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSparklesAmbient6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "none",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "spg",
    cx: "50%",
    cy: "50%",
    r: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "var(--color-accentGold, #FFD95E)",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "var(--color-accentGold, #FFD95E)",
    stopOpacity: 0
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.18,
    style: {
      mixBlendMode: "screen"
    }
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 0.9,
    fill: "url(#spg)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cx",
    values: "10;14;8;10",
    dur: "8s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    values: "90;20;-10;90",
    dur: "8s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;1;0",
    dur: "8s",
    repeatCount: "indefinite"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    r: 0.8,
    fill: "url(#spg)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cx",
    values: "60;55;65;60",
    dur: "7s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    values: "95;30;-5;95",
    dur: "7s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;0.9;0",
    dur: "7s",
    repeatCount: "indefinite"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    r: 0.7,
    fill: "url(#spg)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cx",
    values: "85;80;88;85",
    dur: "9s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    values: "92;25;-8;92",
    dur: "9s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;0.8;0",
    dur: "9s",
    repeatCount: "indefinite"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    @media (prefers-reduced-motion: reduce) { g { opacity: 0.06; } }\n  ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSparklesAmbient6);
export default __webpack_public_path__ + "static/media/sparkles-ambient-6.26d120800cc99e9651e33dc93cad3d23.svg";
export { ForwardRef as ReactComponent };